import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

/**
 * StripeRefresh - Handles refresh redirect from Stripe Connect
 * When Stripe link expires or user needs to restart onboarding
 * Redirects to /host/payouts with refresh flag
 */
const StripeRefresh = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Show info message
    toast.info('Please continue with payout setup');
    
    // Redirect to host payouts with refresh flag
    navigate('/host/payouts?refresh=true', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to payout setup...</p>
      </div>
    </div>
  );
};

export default StripeRefresh;
